import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import AuthNavbar from "../components/Navbars/AuthNavbar";
import AuthFooter from "../components/Footers/AuthFooter";
import inflateRoutes from "../routes";
import { IRouteDefinition } from "../typings";

const Auth = ({ firebaseSvc }: any) => {
  useEffect(() => {
    document.body.classList.add("bg-default");

    return function cleanup() {
      document.body.classList.remove("bg-default");
    };
  });

  const routes = inflateRoutes({ firebaseSvc });

  const getRoutes = (routes: IRouteDefinition[]) => {
    return routes.map((route: IRouteDefinition, index: number) => {
      if (route.layout === "/auth") {
        return (
          <Route
            path={route.layout + route.path}
            render={() => route.component}
            key={index}
          />
        );
      } else {
        return null;
      }
    });
  };

  return (
    <React.Fragment>
      <div className="main-content">
        <AuthNavbar />
        <div className="header bg-gradient-info py-7 py-lg-8">
          <Container>
            <div className="header-body text-center mb-7">
              <Row className="justify-content-center">
                <Col lg="5" md="6">
                  <h1 className="text-white">Welcome!</h1>
                </Col>
              </Row>
            </div>
          </Container>
          <div className="separator separator-bottom separator-skew zindex-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-default"
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div>
        </div>

        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Switch>{getRoutes(routes)}</Switch>
          </Row>
        </Container>
      </div>
      <AuthFooter />
    </React.Fragment>
  );
};

export default Auth;
